import type React from 'react';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { useI18n } from '@change-corgi/core-react/i18n';

export const QRCode: React.FC<EmptyProps> = () => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const { translate } = useI18n();

	return (
		<div className="flex justify-center">
			<div className="size-[140px] rounded-md border border-solid border-[#e5e5e5] bg-white">
				<picture className="flex h-full items-center justify-center">
					<img
						src={getStaticAssetUrl('/images/mobile-app-combined-qr-code-1x.webp')}
						srcSet={`${getStaticAssetUrl('/images/mobile-app-combined-qr-code-1x.webp')} 1x, ${getStaticAssetUrl('/images/mobile-app-combined-qr-code-2x.webp')} 2x`}
						alt={translate('corgi.app_download.bottom_banner_v2.qr_code.image_alt_text')}
						className="w-[130px]"
					/>
				</picture>
			</div>
		</div>
	);
};
